/*
 * MSH 2026-10-19 — White Sole is the default whenever a shoe offers both soles.
 *
 * JB: "the default sole should always be white when there are choices black
 * and white. But if there are no other choices, it should be the black or
 * white sole, so that will be the default."
 *
 * Shopify opens every product on its FIRST variant, and the two-sole shoes are
 * uploaded black set first, so the page and the collection-page size chooser
 * both opened on Black Sole. Changing that in Liquid would mean touching the
 * 29 places the theme reads selected_or_first_available_variant, so instead:
 * as soon as a variant picker is on the page, tick the "White Sole" swatch the
 * way a shopper would (a click on its label), and let the theme do the rest —
 * price, buy button, URL, and the gallery filter (msh-variant-media-filter.js
 * switches the photos inside that same click).
 *
 * Rules:
 *  - Only when the colour option has at least TWO values. A single-colour shoe
 *    (every boot) keeps whatever it has.
 *  - On a product page, a link that already names a variant (?variant=...) is
 *    respected — ads and shares may point at a black pair on purpose.
 *  - Once per product per place, so a shopper who then picks Black is never
 *    flipped back when the theme re-renders the picker. The quick-add chooser
 *    counts afresh on every OPEN: quick-add.js fills it, then re-syncs the
 *    swatch to the card's variant, and only then opens the dialog - so the
 *    default is applied when the <dialog> gains its open attribute, which is
 *    after that sync, and the chooser is still invisible at that point.
 */
(function () {
  var SOLE = /sole/i;
  var WHITE = /white/i;

  function placeOf(picker) {
    return picker.closest('.quick-add-modal') || document.documentElement;
  }

  function productOf(place) {
    var form = place.querySelector('product-form-component[data-product-url]');
    return form ? form.dataset.productUrl : location.pathname;
  }

  function defaultWhite(picker) {
    var place = placeOf(picker);
    var product = productOf(place);
    if (place.dataset.mshWhiteFor === product) return; // already handled here
    place.dataset.mshWhiteFor = product;

    // A deliberate link to a variant on the product page wins.
    if (place === document.documentElement && /[?&]variant=/.test(location.search)) return;

    var radios = Array.prototype.filter.call(
      picker.querySelectorAll('input[type="radio"]'),
      function (r) {
        return SOLE.test(r.value);
      }
    );
    var values = {};
    radios.forEach(function (r) {
      values[r.value] = true;
    });
    if (Object.keys(values).length < 2) return; // no choice to make

    var white = radios.filter(function (r) {
      return WHITE.test(r.value) && !r.disabled;
    })[0];
    if (!white || white.checked) return;

    var label = white.labels && white.labels[0];
    if (label) {
      label.click();
    } else {
      white.checked = true;
      white.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function sweep() {
    document.querySelectorAll('variant-picker').forEach(defaultWhite);
  }

  /** A dialog just opened: whatever it holds gets the default again. */
  function opened(dialog) {
    dialog.querySelectorAll('variant-picker').forEach(function (picker) {
      var place = placeOf(picker);
      if (place !== document.documentElement) delete place.dataset.mshWhiteFor;
      defaultWhite(picker);
    });
  }

  var queued = false;
  function queueSweep() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      sweep();
    });
  }

  function start() {
    // The picker only reacts to a change once it is a real custom element.
    var ready = window.customElements && customElements.whenDefined
      ? customElements.whenDefined('variant-picker')
      : Promise.resolve();
    ready.then(function () {
      sweep();
      // The quick-add chooser arrives later, by fetch.
      new MutationObserver(function (records) {
        var added = false;
        records.forEach(function (r) {
          if (r.type === 'attributes') {
            if (r.target.tagName === 'DIALOG' && r.target.open) opened(r.target);
          } else if (r.addedNodes.length) {
            added = true;
          }
        });
        if (added) queueSweep();
      }).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['open'],
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
